export default __webpack_public_path__ + "static/media/main-screen.123d3ebd.svg";